<template>
  <div class="account-message card-notification border">
    <template v-if="notification.type.includes('banner') && !notification.snoozed">
      <div class="notification card card-secondary">
        <div class="card-header">
          <i class="fa fa-bell"></i>
          <span>{{ notification.name }}</span>
          <span class="badge badge-default">{{ time }}</span>
        </div>
        <div class="card-body">
          <p v-html="notification.message"></p>
        </div>
        <div class="card-footer d-flex justify-content-between">
          <button @click="snooze(notification)" class="btn-sm btn btn-primary">
            <i class="fa fa-bell-slash"></i> Snooze
          </button>
          <button @click="dismiss(notification)" class="btn-sm btn btn-primary">
            <i class="fa fa-times"></i> Dismiss
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Util from '@server/util'
import {
  SNOOZE_NOTIFICATION,
  DISMISS_NOTIFICATION,
  OPEN_NOTIFICATION_MODAL
} from '@/vuex/types'
import { mapActions } from 'vuex'
export default {
  name: 'AccountMessage',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    notification () {
      return {
        ...this.object
      }
    },
    time () {
      let min = moment().diff(moment(this.notification.createdAt), 'minutes')
      if (min < 5) {
        return 'now'
      } else if (min < 60 && min >= 5) {
        return min + ' min ago'
      } else if (min >= 60 && min < 1440) {
        return Util.round(min / 60).toFixed() + ' hours ago'
      } else {
        return Util.round(min / 60 / 24).toFixed() + ' days ago'
      }
    }
  },
  mounted () {
    this.openModal()
  },
  watch: {
    $route () {
      this.openModal()
    }
  },
  methods: {
    openModal () {
      if (this.notification.type.includes('loginMessage')) {
        this.$store.dispatch(OPEN_NOTIFICATION_MODAL, this.notification)
      }
    },
    async executeAction (action, payload) {
      await this[action](payload)
    },
    dismiss (notification) {
      this.executeAction(DISMISS_NOTIFICATION, notification)
    },
    snooze (notification) {
      this.executeAction(SNOOZE_NOTIFICATION, notification)
    },
    ...mapActions([
      SNOOZE_NOTIFICATION,
      DISMISS_NOTIFICATION
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AccountMessage.vue